/**
 * 胶囊分页公共方法（activity-swiper-video / index3-new-youtube-swiper）
 * 配合 singcore-clone-swiper.js 使用：负责圆点高亮与点击，滚动由 CloneSwiper 处理。
 */
(function (global) {
  'use strict';

  function normalizeIndex(index, count) {
    if (!count) return 0;
    return ((index % count) + count) % count;
  }

  /**
   * 更新圆点激活态
   * @param {Element[]|NodeList} dots
   * @param {number} index 逻辑下标
   * @param {number} [count] 总数，默认 dots.length
   */
  function setActive(dots, index, count) {
    var list = Array.prototype.slice.call(dots || []);
    var total = count || list.length;
    if (!total) return;
    var next = normalizeIndex(index, total);
    list.forEach(function (dot, i) {
      var on = i === next;
      dot.classList.toggle('is-active', on);
      if (dot.hasAttribute('aria-current') || on) {
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      }
    });
  }

  /**
   * 绑定圆点点击：读取 data-index，回调 onSelect(logicalIndex)
   * @param {Element[]|NodeList} dots
   * @param {(index: number) => void} onSelect
   * @returns {function(): void} unbind
   */
  function bindClicks(dots, onSelect) {
    var list = Array.prototype.slice.call(dots || []);
    if (!list.length || typeof onSelect !== 'function') {
      return function () {};
    }

    var handlers = list.map(function (dot) {
      var handler = function (e) {
        e.preventDefault();
        var index = Number(dot.getAttribute('data-index'));
        if (Number.isNaN(index)) index = 0;
        onSelect(index);
      };
      dot.addEventListener('click', handler);
      return { dot: dot, handler: handler };
    });

    return function unbind() {
      handlers.forEach(function (item) {
        item.dot.removeEventListener('click', item.handler);
      });
    };
  }

  /**
   * 一次性创建：高亮 + 点击绑定
   * @param {Object} options
   * @param {Element[]|NodeList} options.dots
   * @param {number} [options.count]
   * @param {(index: number) => void} options.onSelect
   * @param {number} [options.initialIndex=0]
   * @returns {{ setActive: function(number): void, unbind: function(): void }}
   */
  function create(options) {
    var opts = options || {};
    var dots = opts.dots || [];
    var count = opts.count || (dots.length || 0);
    var initialIndex = opts.initialIndex || 0;

    setActive(dots, initialIndex, count);
    var unbind = bindClicks(dots, function (index) {
      setActive(dots, index, count);
      if (typeof opts.onSelect === 'function') opts.onSelect(index);
    });

    return {
      setActive: function (index) {
        setActive(dots, index, count);
      },
      unbind: unbind,
    };
  }

  /**
   * 三组克隆循环时的逻辑下标：中间组为 [baseCount, baseCount*2)
   * @param {number} activeIndex
   * @param {number} baseCount
   * @param {boolean} enableLoop
   */
  function logicalFromClonedIndex(activeIndex, baseCount, enableLoop) {
    if (!enableLoop || !baseCount) return activeIndex || 0;
    return normalizeIndex(activeIndex - baseCount, baseCount);
  }

  global.SingcoreCapsulePagination = {
    normalizeIndex: normalizeIndex,
    setActive: setActive,
    bindClicks: bindClicks,
    create: create,
    logicalFromClonedIndex: logicalFromClonedIndex,
  };
})(typeof window !== 'undefined' ? window : this);
